/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ComplimentaryInputs */

const en_complimentary = /** @type {(inputs: ComplimentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complimentary`)
};

const es_complimentary = /** @type {(inputs: ComplimentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De cortesía`)
};

const fr_complimentary = /** @type {(inputs: ComplimentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offert`)
};

const de_complimentary = /** @type {(inputs: ComplimentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenfrei`)
};

const ja_complimentary = /** @type {(inputs: ComplimentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料提供 / 補足`)
};

const zh_complimentary = /** @type {(inputs: ComplimentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费赠送`)
};

const ar_complimentary = /** @type {(inputs: ComplimentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجاني (هدية)`)
};

const id_complimentary = /** @type {(inputs: ComplimentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bebas Biaya`)
};

const it_complimentary = /** @type {(inputs: ComplimentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Omaggio`)
};

const ru_complimentary = /** @type {(inputs: ComplimentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатно/В подарок`)
};

const pt_complimentary = /** @type {(inputs: ComplimentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De cortesia`)
};

const ko_complimentary = /** @type {(inputs: ComplimentaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 제공`)
};

/**
* | output |
* | --- |
* | "Complimentary" |
*
* @param {ComplimentaryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const complimentary = /** @type {((inputs?: ComplimentaryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ComplimentaryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_complimentary(inputs)
	if (locale === "es") return es_complimentary(inputs)
	if (locale === "fr") return fr_complimentary(inputs)
	if (locale === "de") return de_complimentary(inputs)
	if (locale === "ja") return ja_complimentary(inputs)
	if (locale === "zh") return zh_complimentary(inputs)
	if (locale === "ar") return ar_complimentary(inputs)
	if (locale === "id") return id_complimentary(inputs)
	if (locale === "it") return it_complimentary(inputs)
	if (locale === "ru") return ru_complimentary(inputs)
	if (locale === "pt") return pt_complimentary(inputs)
	return ko_complimentary(inputs)
});